
import dummyImg from 'assets/images/dummyImg.svg'
import star from 'assets/images/smStar.svg';
const CabRideData = {
  "rideDetails":[
  {
    "id":"123456",
    "rider_name":'Vipin Singh',
    "driver_name": "Pushpendra Singh Pal",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123457",
    "rider_name":'Rahul Singh1',
    "driver_name": "Rahul Pal1",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Runing"
  },
  {
    "id":"123458",
    "rider_name":'Rahul Singh2',
    "driver_name": "Rahul Pal2",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123459",
    "rider_name":'Rahul Singh3',
    "driver_name": "Rahul Pal3",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Pending"
  },
  {
    "id":"123456",
    "rider_name":'Rahul Singh',
    "driver_name": "Rahul Pal",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123457",
    "rider_name":'Rahul Singh1',
    "driver_name": "Rahul Pal1",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Runing"
  },
  {
    "id":"123458",
    "rider_name":'Rahul Singh2',
    "driver_name": "Rahul Pal2",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123459",
    "rider_name":'Rahul Singh3',
    "driver_name": "Rahul Pal3",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Pending"
  },
  {
    "id":"123457",
    "rider_name":'Rahul Singh1',
    "driver_name": "Rahul Pal1",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Runing"
  },
  {
    "id":"123458",
    "rider_name":'Rahul Singh2',
    "driver_name": "Rahul Pal2",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123459",
    "rider_name":'Rahul Singh3',
    "driver_name": "Rahul Pal3",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Pending"
  },
  {
    "id":"123456",
    "rider_name":'Rahul Singh',
    "driver_name": "Rahul Pal",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123457",
    "rider_name":'Rahul Singh1',
    "driver_name": "Rahul Pal1",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Runing"
  },
  {
    "id":"123458",
    "rider_name":'Rahul Singh2',
    "driver_name": "Rahul Pal2",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Completed"
  },
  {
    "id":"123459",
    "rider_name":'Rahul Singh3',
    "driver_name": "Rahul Pal3",
    "pick_up": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "dropping": "#265, 2nd Floor, 6th Main, 4th Cross Rd, .....",
    "price": "₹1,89,774",
    "status": "Pending"
  },
],
'acceptenceData':[
  {
    "name":"Zara",
    "status":"accepted",
    "id": "2564749686",
    "url": dummyImg,
    "date": "45min before trip (Today, 11:59 AM)"
  },
  {
    "name":"Zara2",
    "status":"rejected",
    "id": "2564749687",
    "url": dummyImg,
    "date": "45min before trip (Today, 11:59 AM)"
  },
  {
    "name":"Zara3",
    "status":"accepted",
    "id": "2564749688",
    "url": dummyImg,
    "date": "45min before trip (Today, 11:59 AM)"
  },
  {
    "name":"Zara4",
    "status":"accepted",
    "id": "2564749689",
    "url": dummyImg,
    "date": "45min before trip (Today, 11:59 AM)"
  }
],
'feedbackData':[
  {
    "name":"Ramu Shrama", 
    "feedback":"Excellent",
    "rating": "5",
    "url": dummyImg,
  },
  {
    "name":"Raju Katari", 
    "feedback":"Good",
    "rating": "3",
    "url": dummyImg,
  },
  {
    "name":"Panduranga", 
    "feedback":"Poor",
    "rating": "2",
    "url": dummyImg,
  },
  {
    "name":"Dingru", 
    "feedback":"Excellent",
    "rating": "4",
    "url": dummyImg,
  },
  {
    "name":"John", 
    "feedback":"Very Bad",
    "rating": "1",
    "url": dummyImg,
  },
]
}
export default CabRideData;


export const filterdata = [
  
  {
    id: 1,
    primaryText: 'Location',
    isOpen: true,
    subItems: [
      { label: 'Bangalore', value: 'Bangalore' },
      { label: 'Chennai', value: 'Chennai' },
      { label: 'Mysore', value: 'Mysore' },
      { label: 'Kannur', value: 'Kannur' }
    ]
  }
]


export const cabRidedataFilter = [
  {
    id: 1,
    primaryText: 'Status',
    isOpen: true,
    subItems: [
      { label: 'Active', value: 'Active' },
      { label: 'Upcoming', value: 'Upcoming' },
      { label: 'Completed', value: 'Completed' },
    ]
  },
]

export const driverFilter = [
  // {
  //   id: 1,
  //   primaryText: 'Rating',
  //   isOpen: true,
  //   star: star,
  //   subItems: [
  //     { label: '5', value: '5' },
  //     { label: '4', value: '4' },
  //     { label: '3', value: '3' },
  //     { label: '2', value: '2' },
  //     { label: '1', value: '1' },
  //   ]
  // },
  {
    id: 1,
    primaryText: 'Status',
    subItems: [
      { value: 'Active', key: 'Status' },
      { value: 'InActive', key: 'Status' },
      { value: 'Blocked', key: 'Status' },
      { value: 'Pending', key: 'Status' }
    ]
  }
]